<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="walletForm" *ngIf="this.walletForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    {{pagetitle}}{{userName}}
                                </h3>
                            </div>
                        </div>
                            <div class="walletNote">
                                <div class="Available-details">
                                    <h5>Available Cash : {{totalAvailableCash | number:'1.2-2'}}</h5>
                                    <span class="pipe"></span>
                                    <h5>Available Coins : {{totalAvailableCoins | number:'1.2-2'}}</h5>
                                </div>
                            </div>
                        <div class="cashHeading ">
                            <label *ngIf="cash">Coins ? </label>
                            <label *ngIf="coins">Cash ? </label>
                            <p-inputSwitch (onChange)="onClickCashOrCoin($event)"></p-inputSwitch>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div *ngIf="cash" class="p-field p-col-4">
                                    <label for="cash">Cash <span class="mandatory-fields">*</span></label>

                                    <p-inputNumber mode="decimal" formControlName="cash"
                                        [ngClass]="{ 'is-invalid': submitted && f.cash.errors }" required>
                                    </p-inputNumber>
                                    <div *ngIf="submitted && f.cash.errors" class="invalid-feedback">
                                        <div *ngIf="f.cash.errors.required">Cash is required</div>
                                    </div>
                                </div>
                                <div *ngIf="coins" class="p-field p-col-4">
                                    <label for="cash">Coins <span class="mandatory-fields">*</span></label>

                                    <p-inputNumber mode="decimal" formControlName="coins"
                                        [ngClass]="{ 'is-invalid': submitted && f.coins.errors }" required>
                                    </p-inputNumber>
                                    <div *ngIf="submitted && f.coins.errors" class="invalid-feedback">
                                        <div *ngIf="f.coins.errors.required">Coins is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-8">
                                    <label for="description">Description <span class="mandatory-fields">*</span></label>
                                    <!-- <input formControlName="name" type="text" pInputText class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.name.errors }"> -->
                                    <textarea name="description" rows="3" formControlName="description"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                    <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                        <div *ngIf="f.description.errors.required">description is required</div>
                                        <div *ngIf="!f.description.errors.required && f.description.errors ">description
                                            invalid
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>

                                <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                                    <div class="p-formgrid p-grid">
                                        <p-toast></p-toast>
                                        <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                            class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                                        <button type="text" (click)="backLink()" pButton icon="pi pi-times"
                                            label="Cancel" class="p-button-danger cancel-btn"
                                            style="width: auto"></button>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div *ngIf="errorMessage" class="invalid-feedback">
                            <div>{{errorMessage}}</div>
                        </div>
                    </form>
                </div>
            </div>

        </div>

    </div>
</div>
<p-toast></p-toast>
<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>